import { ChevronLeft, ChevronRight } from "lucide-react";
import { ARTICLE_PAGE_SIZE_OPTIONS, getPaginationSummary } from "../utils/pagination";

export function PaginationControls({
  pageIndex,
  pageSize,
  totalRows,
  onPageIndexChange,
  onPageSizeChange
}: {
  pageIndex: number;
  pageSize: number;
  totalRows: number;
  onPageIndexChange: (pageIndex: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}) {
  const summary = getPaginationSummary(totalRows, pageIndex, pageSize);

  return (
    <div className="pagination-bar">
      <span>
        顯示 {summary.start}-{summary.end} / {summary.totalRows}
      </span>
      <label className="page-size-field">
        <span>每頁</span>
        <select value={summary.pageSize} onChange={(event) => onPageSizeChange(Number(event.target.value))}>
          {ARTICLE_PAGE_SIZE_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </label>
      <div className="pagination-actions">
        <button
          type="button"
          title="上一頁"
          disabled={summary.pageIndex === 0}
          onClick={() => onPageIndexChange(summary.pageIndex - 1)}
        >
          <ChevronLeft size={16} aria-hidden="true" />
        </button>
        <span>
          {summary.pageIndex + 1} / {summary.pageCount}
        </span>
        <button
          type="button"
          title="下一頁"
          disabled={summary.pageIndex >= summary.pageCount - 1}
          onClick={() => onPageIndexChange(summary.pageIndex + 1)}
        >
          <ChevronRight size={16} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
